import { PostEffect } from "./PostEffect";
import { PostEffectsInput } from "./PostEffectsPipeline";
import * as fs from "fs";

export class BloomPostEffect extends PostEffect {
  private readonly bloomTextureLocation: WebGLUniformLocation;

  constructor(
    gl: WebGL2RenderingContext,
    private readonly bloomTexture: WebGLTexture,
  ) {
    super(
      gl,
      "Bloom Add",
      fs.readFileSync(__dirname + "/effects/bloom_add.frag", "utf8"),
    );

    this.bloomTextureLocation = gl.getUniformLocation(this.shader, "bloom")!;
    gl.useProgram(this.shader);
    this.gl.uniform1i(this.bloomTextureLocation, 2);
    gl.useProgram(null);
  }

  protected setUniforms(input: PostEffectsInput) {
    super.setUniforms(input);
  }

  protected beforeQuadRender() {
    this.gl.activeTexture(this.gl.TEXTURE2);
    this.gl.bindTexture(this.gl.TEXTURE_2D, this.bloomTexture);
  }
}
